import { ampli } from "@saas/core";

export const trackUpdateEmailSuccess = () => {
  ampli.editProfile({
    action: "click_change_email",
  });

  ampli.identify(undefined, {
    account_verified: false,
  });
};

export const trackUpdateEmailError = () => {
  ampli.editProfile({
    action: "click_change_email",
  });
};

export const trackUpdatePasswordSuccess = () => {
  ampli.editProfile({
    action: "click_change_password",
  });
};

export const trackUpdatePasswordError = () => {
  ampli.editProfile({
    action: "click_change_password",
  });
};

export const trackUpdateProfileSuccess = (username: string) => {
  ampli.editProfile({
    action: "click_update_general_information",
  });

  ampli.identify(undefined, {
    name: username,
  });
};

export const trackUpdateProfileError = () => {
  ampli.editProfile({
    action: "click_update_general_information",
  });
};

export const trackResendVerificationLink = () => {
  ampli.resendVerification({
    action: "click_resend_verification_link",
  });
};

export const trackMissionBanner = (
  missionType: "Verify Email" | "Add Marketplace"
) => {
  ampli.clickMission({
    action: "click_mission_action_button",
    mission_name: missionType,
  });
};

export const trackCompleteMissionBanner = () => {
  ampli.finishMission({
    action: "click_complete_mission_button",
  });
};

export const trackLoginSuccess = (
  userId: string,
  username: string,
  verified: boolean
) => {
  ampli.loginAccount({
    action: "click_login_button",
    login_status: true,
  });

  ampli.identify(userId, {
    account_verified: verified,
    name: username,
  });
};

export const trackLoginError = () => {
  ampli.loginAccount({
    action: "click_login_button",
    login_status: false,
  });
};

export const trackRegisterSuccess = (
  userId: string,
  username: string,
  verified: boolean,
  registerTo?: string
) => {
  ampli.registerAccount({
    action: "click_register_button",
    register_status: true,
    register_to: registerTo,
  });

  ampli.identify(userId, {
    account_verified: verified,
    name: username,
  });
};

export const trackRegisterError = (registerTo?: string) => {
  ampli.registerAccount({
    action: "click_register_button",
    register_status: false,
    register_to: registerTo,
  });
};

export const trackAccountType = (
  userId: string,
  haveSubaccount: boolean,
  accountLevel: "parent_account" | "sub_account"
) => {
  ampli.identify(userId, {
    have_sub_account: haveSubaccount,
    account_level: accountLevel,
  });
};
